import React, { forwardRef, useState, useImperativeHandle } from 'react';
import styles from './index.module.scss';

const avatarUrls = [
  'https://imgcdn.sto.cn/6D262470-52CE-4A-284x260-08AFE13A-D794-4A42-B9D1-2B62D95DBDE7.png',
  'https://imgcdn.sto.cn/6DB1F4E5-BC27-40-284x260-B29ABA26-464B-4105-AA7F-D1DDEA18C050.png',
  'https://imgcdn.sto.cn/4C9217D6-C25F-49-256x256-0D9BD58E-561F-41BA-A4E0-2CF222EEC039.png'
];

const RobotList = ({ list, robotInfo }, ref) => {
  const [choosed, setChoosed] = useState(robotInfo);
  useImperativeHandle(ref, () => ({
		choosed
	}));

	return (
    <ul className={styles.robotList}>

      {list?.map((item, index) => (
        <li
          key={item.robotCode}
          className={`${styles.robot} ${choosed.robotCode === item.robotCode ? styles.choosed : ''}`}
          onClick={() => setChoosed(item)}
        >
          <img className={styles.robotAvatar} src={item.avatar ?? avatarUrls[index % 3]} alt="" onError={(e) => { (e.target as HTMLImageElement).src = avatarUrls[index % 3]; }} />
          {item.robotName}
        </li>
      ))}
    </ul>
  );
};

export default forwardRef(RobotList);
